import SignIn from '../pages/signIn/Signin';
import SignUp from '../pages/signUp/SignUp';
import ForgotPassword from '../pages/forgotPwd/ForgotPwd';
import Dashboard from '../pages/dashboard/Dashboard';
import Report from '../pages/report/Report';
import ProjectManager from '../pages/projectmanager/ProjectManager';
import Roles from '../pages/roles/roles';
import ForgotUsername from '../pages/forgotUsername/forgotUsername';
import AssignRole from '../pages/roles/assignRoles';

const Empty = () => null; // Prevents unwanted pages from showing

const CommonRoutes = [
    {
        path: '/',
        component: Empty,
        exact: true
    },
    {
        path: '/signup',
        component: Empty,
        exact: true,
    },
    {
        path: '/forgot-password',
        component: Empty,
        exact: true,
    },
    {
        path: '/forgot-username',
        component: Empty,
        exact: true,
    }
];

const RestrictedRoutes = [
    {
        path: '/dashboard',
        component: Dashboard,
        exact: true
    },
    {
        path: '/report',
        component: Report,
        exact: true
    },
    {
        path: '/project-manager',
        component: ProjectManager,
        exact: true
    },
    {
        path: '/roles',
        component: Roles,
        exact: true,
        requireGlobalAdmin: true
    },
    {
        path: '/manage-role',
        component: AssignRole,
        exact: true
    }
];

export { CommonRoutes, RestrictedRoutes };